export default __webpack_public_path__ + "static/media/summer.8ff34345.jpg";